var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorporateExternalDataDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#142533"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9999 31L59.9999 29H44.9998C44.1194 29.2143 43.6685 29.4134 43 29.9999L39 33.9999C38.3897 34.6523 38.1387 35.0869 37.9998 36V61L39.9998 63H59.9999L61.9999 61V31ZM59.9999 61H39.9998V36.5H43.9998L45.4998 35V31H59.9999V61ZM39.9998 35L43.9998 31V35H39.9998Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9998 36.5C43.9998 36.5 44.6911 36.3088 44.9998 36C45.3086 35.6913 45.4998 35 45.4998 35L43.9998 36.5Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4999 29.5C60.9476 28.9477 59.9999 29 59.9999 29L61.9999 31C61.9999 31 62.0521 30.0523 61.4999 29.5Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4999 62.5C62.0521 61.9477 61.9999 61 61.9999 61L59.9999 63C59.9999 63 60.9476 63.0523 61.4999 62.5Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 62.5C39.0523 63.0523 39.9998 63 39.9998 63L37.9998 61C37.9998 61 37.9477 61.9477 38.5 62.5Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63V70H24V63H22V72H79V63H77V70H51V63H49Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0013 31.0013L87.0013 29.0013H72.0013C71.1209 29.2157 70.67 29.4148 70.0015 30.0012L66.0015 34.0012C65.3912 34.6536 65.1401 35.0882 65.0013 36.0013V61.0013L67.0013 63.0013H87.0013L89.0013 61.0013V31.0013ZM87.0013 61.0013H67.0013V36.5013H71.0013L72.5013 35.0013V31.0013H87.0013V61.0013ZM67.0013 35.0013L71.0013 31.0013V35.0013H67.0013Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0013 36.5013C71.0013 36.5013 71.6926 36.3101 72.0013 36.0013C72.3101 35.6926 72.5013 35.0013 72.5013 35.0013L71.0013 36.5013Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5013 29.5013C87.949 28.949 87.0013 29.0013 87.0013 29.0013L89.0013 31.0013C89.0013 31.0013 89.0536 30.0536 88.5013 29.5013Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5013 62.5013C89.0536 61.949 89.0013 61.0013 89.0013 61.0013L87.0013 63.0013C87.0013 63.0013 87.949 63.0536 88.5013 62.5013Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5015 62.5013C66.0538 63.0536 67.0013 63.0013 67.0013 63.0013L65.0013 61.0013C65.0013 61.0013 64.9492 61.949 65.5015 62.5013Z",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0013 31.0013L33.0013 29.0013H18.0013C17.1209 29.2157 16.67 29.4148 16.0015 30.0012L12.0015 34.0012C11.3912 34.6536 11.1401 35.0882 11.0013 36.0013V61.0013L13.0013 63.0013H33.0013L35.0013 61.0013V31.0013ZM33.0013 61.0013H13.0013V36.5013H17.0013L18.5013 35.0013V31.0013H33.0013V61.0013ZM13.0013 35.0013L17.0013 31.0013V35.0013H13.0013Z",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 36.5013C17.0013 36.5013 17.6926 36.3101 18.0013 36.0013C18.3101 35.6926 18.5013 35.0013 18.5013 35.0013L17.0013 36.5013Z",
    fill: "#D9D9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5013 29.5013C33.949 28.949 33.0013 29.0013 33.0013 29.0013L35.0013 31.0013C35.0013 31.0013 35.0536 30.0536 34.5013 29.5013Z",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5013 62.5013C35.0536 61.949 35.0013 61.0013 35.0013 61.0013L33.0013 63.0013C33.0013 63.0013 33.949 63.0536 34.5013 62.5013Z",
    fill: "#D9D9D9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5015 62.5013C12.0538 63.0536 13.0013 63.0013 13.0013 63.0013L11.0013 61.0013C11.0013 61.0013 10.9492 61.949 11.5015 62.5013Z",
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 59V46H21.5V59H19.5Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15 59H17V50H15V59Z",
    fill: "#D9D9D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59V42H26V59H24Z",
    fill: "#D9D9D9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 59V38H30.5V59H28.5Z",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47 33H52V35H47V33Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 43H58.5V45H41.5V43Z",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 38V40H51.5V38H41.5Z",
    fill: "#D9D9D9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 38V40H58.5V38H53.5Z",
    fill: "#D9D9D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 33H58.5V35H53.5V33Z",
    fill: "#D9D9D9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 58V60H58.5V58H41.5Z",
    fill: "#D9D9D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 53H49V55H41.5V53Z",
    fill: "#D9D9D9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53H58.5V55H51V53Z",
    fill: "#D9D9D9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 48V50H58.5V48H48.5Z",
    fill: "#D9D9D9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 48H46.5V50H41.5V48Z",
    fill: "#D9D9D9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82 56L77.5 49.5L79 48L85 53L85.5 52.5L79 47.5C77.9784 48.8044 77.1774 48.8544 75.5 49.5H76.5H77L81.5 56.5L82 56Z",
    fill: "#D9D9D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53C84.2916 54.8206 83.6966 55.5662 82 56L81.5 56.5C84.4978 56.0286 85.0778 54.922 85.5 52.5L85 53Z",
    fill: "#D9D9D9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 45C80 47.7614 77.7614 50 75 50C72.2386 50 70 47.7614 70 45C70 42.2386 72.2386 40 75 40C77.7614 40 80 42.2386 80 45ZM75 49C77.2091 49 79 47.2091 79 45C79 42.7909 77.2091 41 75 41C72.7909 41 71 42.7909 71 45C71 47.2091 72.7909 49 75 49Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorporateExternalDataDataIcon);
export default __webpack_public_path__ + "static/media/IncorporateExternalDataDataIcon.a8b909e08d5305a3dbfdec74605ddac6.svg";
export { ForwardRef as ReactComponent };